import  tokens  from '@tableau/design-tokens';

import { applyColor } from '~src/style/ColorService';

import { cssClass } from '../../../style';

const cssPrefix = 'personal-space';

export namespace PersonalSpaceStyles {
  export const linkButton = cssClass(cssPrefix, 'linkButton', {
    background: 'none',
    border: '1px solid transparent',
    cursor: 'pointer',
    textDecoration: 'underline',
    display: 'inline',
    margin: 0,
    padding: 0,
    color: applyColor(tokens.color.link.inline.default.default, '#1a699e'),
    fontSize: 'inherit',
    fontFamily: 'inherit',
    transition: 'color 0.2s ease',
    $nest: {
      '&:hover': {
        color: applyColor(tokens.color.link.inline.default.hover, '#2a79af'),
        textDecoration: 'underline'
      },
      '&:focus': {
        color: applyColor(tokens.color.font.default.default, '#2e2e2e'),
        border: `1px solid ${applyColor(tokens.color.elevation.border.default.dark, '#1a699e')}`,
        boxShadow: `0 0 4px 0 ${applyColor(tokens.color.font.default.default, '#1a699e')}`,
        textDecoration: 'underline',
        outline: 'none'
      },
      '&:active': {
        color: applyColor(tokens.color.link.inline.default.active, '#15557f')
      }
    }
  });
}
